const styles = {
    buttons: {
        float: 'right'
    },
    container: {
        position: 'relative',
        margin: '-23px 0 0 -5px',
        height: 'calc(100vh - 57px)'
    },
    map: {
        height: 300
    },
    rightIcon: {
        position: 'absolute',
        right: 10
    },
    mapFull: {
        height: '80vh'
    },
    avatar: {
        verticalAlign: 'middle',
        display: 'block',
        margin: 'auto',
        marginBottom: 40,
        overflow: 'hidden',
        '& img': {
            width: '100%',
            height: '100%',
            margin: 0
        }
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/quiz/QuizPage/QuizPage.css.js